import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/AuthService/auth.service'; 

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      console.log('Usuário autenticado');
      return true; 
    } else {
      console.log('Usuário não autenticado');
      this.router.navigate(['/login']); 
      return false;
    }
  }
}